module.exports = __webpack_public_path__ + "img/cap1_qubit.46a89005.svg";